/**
 * Static event posters — no backend required.
 * 1. Add images to: client/public/events/
 * 2. List each path below (e.g. '/events/poster-1.jpg')
 */
export const eventPosters = [
  // '/events/poster-1.jpg',
];
